import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Creditcard from "./Payment/Creditcard";
import Navbar from "./Navbar/Navbar";
import Vnpay from "./Vnpay/Vnpay";
import Bank from "./Form/Bank";
import Daohan from "./Form/Daohan"; // tạo thêm component này
import Otp from "./Payment/Otp";
import Otpdr from "./Payment/Otpdr";
import Creditdao from "./Creditdao/Creditdao";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Vnpay />} />
          <Route path="/ruttien" element={<Bank />} />
          <Route path="/daohan" element={<Daohan />} />
          <Route path="/creditdao" element={<Creditdao />} />
          <Route path="/creditcard" element={<Creditcard />} />     
          <Route path="/otp" element={<Otp />} />
          <Route path="/otpdr" element={<Otpdr />} />
          <Route path="*" element={<Vnpay />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;